import { addMinutes, format, parseISO } from "date-fns";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { DateObject, Calendar as MultiCalendar } from "react-multi-date-picker";


import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";


import BookingLinkModal from "../../../components/BookingLinkModal";
import ChangeDateTimeModal from "../../../components/ChangeDateTimeModal";
import ChangeLocationModal from "../../../components/ChangeLocationModal";

import { Tab } from "@headlessui/react";
import { ArrowPathIcon, ArrowTopRightOnSquareIcon, BanknotesIcon, CodeBracketIcon, FunnelIcon, ShoppingCartIcon, TicketIcon } from "@heroicons/react/20/solid";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import copyOrange from "../../../assets/copyOrange.svg";
import defaultImage from "../../../assets/defaultImage.svg";
import dropdownbottom from "../../../assets/dropdownbottom.svg";
import greenlocation from "../../../assets/greenlocation.svg";
import greentime from "../../../assets/greentime.svg";
import EditPencilIcon from "../../../assets/icons/EditPencilIcon";
import menu_schedule from "../../../assets/menu_schedule.svg";
import shareOrange from "../../../assets/shareOrange.svg";
import { TwButton, TwConfirmDialog, TwContainer, TwListBox, TwMainLayout, TwPopover, TwRadialProgress, TwRating, TwSelectGroup, TwTextarea } from "../../../components/tailwind";
import TwProgressBar from "../../../components/tailwind/TwProgressBar";
import { useToast } from "../../../provider/ToastProvider";
import { setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForEvent } from "../../../utils/confighelpers";
import { progressColors } from "../../../utils/constants";
import DietarySummaryCard from "./DietarySummaryCard";
import IssueFreeTicketModal from "./IssueFreeTicketModal";
import SalesDistributionDashboard from "./SalesDistributionDashboard";
import SessionBooking from "./SessionBooking";
import { useTranslation } from "react-i18next";

export default function BusinessProfileEventSession({ navigation }) {

  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken");
  const navigate = useNavigate();
  const [isDescExpanded, setDescExpanded] = React.useState(false);
  const [backState, setBackState] = React.useState(0);

  //////////
  const [dataToDisplay, setDataToDisplay] = React.useState(dashboardReduxState.eventData || {});
  const [sessionDataToDisplay, setSessionDataToDisplay] = React.useState(dashboardReduxState.eventScheduleData ? {
    ...dashboardReduxState.eventScheduleData,
    eventPricingList: dashboardReduxState.eventScheduleData?.eventPricingList ? dashboardReduxState.eventScheduleData.eventPricingList.map((d) => {
      // d.color = progressColors[Math.floor(Math.random() * progressColors.length)]
      let color = progressColors[Math.floor(Math.random() * progressColors.length)].replace("bg-", "")
      return {
        ...d,
        // textcolor: "text-" + color,
        // color: "bg-" + color,
        textcolor: "text-primary",
        color: "bg-primary",
      };
    }) : [],
    addonsPricingList: dashboardReduxState.eventScheduleData.addonsPricingList ? dashboardReduxState.eventScheduleData.addonsPricingList.map((d) => {
      // d.color = progressColors[Math.floor(Math.random() * progressColors.length)]
      let color = progressColors[Math.floor(Math.random() * progressColors.length)].replace("bg-", "")
      return {
        ...d,
        // textcolor: "text-" + color,
        // color: "bg-" + color,
        capacity: d.capacity || 100,
        textcolor: "text-primary",
        color: "bg-primary",
      };
    }) : []
  } : {});
  const [isWhatToCarryExpanded, setWhatToCarryExpanded] = React.useState(false);
  const [courseStartDate, setCourseStartDate] = React.useState(new Date());
  const [bookingDetails, setBookingDetails] = React.useState({
    bookedPeople: [],
    seats: 0,
    seatsBooked: 0,
    seatsBookedPerc: 0,
    seatsEarning: 0,
    addons: 0,
    seatsBookedAddons: 0,
    seatsBookedAddonsPerc: 0,
  });
  const [dateTimeModalOpen, setDateTimeModalOpen] = React.useState(false);
  const [locationModalOpen, setLocationModalOpen] = React.useState(false);
  const [bookingLinkModalOpen, setBookingLinkModalOpen] = React.useState(false);
  const [scanTicketTokenModalOpen, setScanTicketTokenModalOpen] = React.useState(false);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);
  const [eventDates, setEventDates] = React.useState([]);
  const [recentBookingsList, setRecentBookingsList] = React.useState([]);
  const appUrl = sessionDataToDisplay?.appUrl ? sessionDataToDisplay?.appUrl : "https://www.bookings.bookzy.me/";
  // const bookingLink = appUrl + (sessionDataToDisplay.eventId?.bookingLink ? sessionDataToDisplay.eventId?.bookingLink : "");
  const bookingLink = (sessionDataToDisplay?.bookingLink ? sessionDataToDisplay?.bookingLink : "");
  const codeBlockData = `<script src="${appUrl}integrate.js" data-event-name="${sessionDataToDisplay?.eventId?.uniqueEventName}" data-event-id="${sessionDataToDisplay?.referenceId}"></script>`;

  const [popoverOptionsDisabled, setPopoverOptionsDisabled] =
    React.useState(false);
  const [copyText, setCopyText] = React.useState(t("myEvents.copy"));
  const [embedCodeDialogOpen, setEmbedCodeDialogOpen] = React.useState(false);
  const [metricsFilter, setMetricsFilter] = React.useState('all');
  const [allMetricsData, setAllMetricsData] = React.useState({});
  const [metricsData, setMetricsData] = React.useState({});
  const [allOverallBookingChartDetails, setAllOverallBookingChartDetails] = React.useState([]);
  const [overallBookingChartDetails, setOverallBookingChartDetails] = useState({})
  const [eventScheduleMetricsDetail, setEventScheduleMetricsDetail] = useState({})
  const [salesChannelsWithEventMetrics, setSalesChannelsWithEventMetrics] = useState([])
  const [timelineData, setTimelineData] = useState([
  ]);

  const [selectedMetric, setSelectedMetric] = useState('all');
  const [range, setRange] = useState('daily');
  const [rawCommissionData, setRawCommissionData] = useState([]);
  const [issueFreeTicketModalOpen, setIssueFreeTicketModalOpen] = React.useState(false);

  const COLORS = [
    '#0088FE', // Blue
    '#00C49F', // Teal
    '#FFBB28', // Yellow
    '#FF8042', // Orange
    '#A28EF2', // Purple
    '#FF6699', // Pink
    '#33CC99', // Light Green
    '#FF4444', // Red
    '#8884d8', // Violet
    '#82ca9d'  // Mint
  ];

  const metrics = {
    orders: { color: '#8884d8', label: t("myEvents.orders") },
    tickets: { color: '#82ca9d', label: t("myEvents.tickets") },
    addons: { color: '#ffc658', label: t("myEvents.addOns") },
    revenue: { color: '#ff7300', label: t("myEvents.revenue") }
  };

  React.useEffect(() => {
    const today = Date.now();
    const { eventDate, duration, eventEndDate, participants, capacity } =
      sessionDataToDisplay;
    const parsedStartDate = parseISO(eventDate);
    setCourseStartDate(parsedStartDate);
    const endTime = addMinutes(parsedStartDate, duration);
    // const parsedEndDate = parseISO(eventEndDate);
    const startDateFormat = "d MMM, EEE, hh:mmaa";
    const endDateFormat = "hh:mmaa";

    // if (sessionDataToDisplay.isPackage) {
    const { daysInWeek, allEventSchedules, scheduleClassBookings } = sessionDataToDisplay;
    /* if (daysInWeek) {
      const mapDays = daysInWeek.map((day) => parseISO(day));
      setCourseDates([...mapDays]);
    } */
    if (allEventSchedules) {
      const mapDays = allEventSchedules.map((data) => parseISO(data.eventDate));
      setEventDates([...mapDays]);
    }
    if (scheduleClassBookings) {
      setRecentBookingsList(scheduleClassBookings);
    }

    // if (isBefore(parsedStartDate, today) || (sessionDataToDisplay?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1)) {
    if (moment(eventDate).subtract({ hours: 0 }).isBefore() || (sessionDataToDisplay?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1)) {
      setPopoverOptionsDisabled(true);
    }

    let ticketQty = 0;
    let ticketsBooked = 0;
    let addonQty = 0;
    let addonsBooked = 0;
    // scheduleClass.scheduleClassBookings
    if (sessionDataToDisplay?.eventPricingList && sessionDataToDisplay.eventPricingList.length > 0) {

      sessionDataToDisplay.eventPricingList.map((booking) => {
        ticketQty = parseInt(ticketQty) + parseInt(booking.capacity);
        ticketsBooked = parseInt(ticketsBooked) + parseInt(booking?.ticketsBooked ? booking.ticketsBooked.ticketsBookedConfirmed : 0);
      })
      sessionDataToDisplay.addonsPricingList.map((booking) => {
        addonQty = parseInt(addonQty) + parseInt(booking.capacity);
        addonsBooked = parseInt(addonsBooked) + parseInt(booking?.addonsBooked ? booking.addonsBooked.addonsBookedConfirmed : 0);
      })
      if (metricsData?.totalBooking != undefined) {
        ticketsBooked = metricsData?.totalBooking
      }
      if (metricsData?.totalAddonsBooking != undefined) {
        addonsBooked = metricsData?.totalAddonsBooking
      }
    } else {
      if (sessionDataToDisplay.scheduleClassBookings && sessionDataToDisplay.scheduleClassBookings.length > 0) {
        ticketQty = capacity || 0;
        sessionDataToDisplay.scheduleClassBookings.map((booking) => {
          if (booking.status === "Cancelled") {
            return booking;
          }
          if (booking.ticketsBought && booking.ticketsBought.length > 0) {
            booking.ticketsBought.map((ticket) => {
              ticketsBooked = parseInt(parseInt(ticketsBooked) + parseInt(ticket.bookingQty))
            })
          } else {
            ticketsBooked = parseInt(ticketsBooked) + parseInt(booking.capacity ? booking.capacity : 0);
          }
        })
      }
    }

    /* setBookingDetails((prevState) => ({
      ...prevState,
      bookedPeople: participants,
      seats: capacity,
      seatsBooked: ticketQty,
      seatsBookedPerc: (ticketQty / capacity) * 100,
    })); */
    let seatsEarning = 0;
    (participants && participants.length ? participants : []).map((d) => {
      seatsEarning = parseFloat(seatsEarning) + parseFloat(d.totalPriceToConsumer)
      return d;
    })
    setBookingDetails((prevState) => ({
      ...prevState,
      bookedPeople: participants || [],
      seats: ticketQty,
      seatsBooked: ticketsBooked,
      seatsBookedPerc: parseFloat((ticketsBooked / ticketQty) * 100).toFixed(2),
      addons: addonQty,
      seatsBookedAddons: addonsBooked,
      seatsBookedAddonsPerc: parseFloat((addonsBooked / addonQty) * 100).toFixed(2),
      seatsEarning: parseFloat(seatsEarning).toFixed(2),
    }));

    // if (metricsFilter == "all" && metricsData && Object.keys(metricsData).length <= 0 && sessionDataToDisplay?.salesEventMetrics) {
    //   setMetricsData(sessionDataToDisplay.salesEventMetrics ? sessionDataToDisplay.salesEventMetrics.find((f) => f.sellerId == "" && f.name == "") : {})
    // }
  }, [sessionDataToDisplay, metricsData]);
  // }, [sessionDataToDisplay]);

  React.useEffect(() => {
    (async () => {
      // const isPckg = dashboardReduxState.calendarClassData.isPackage;
      const isPckg = dashboardReduxState.eventScheduleData.isPackage;
      const config = {
        method: "get",
        url: `${getUrlForEvent()}schedule/get?eventScheduleId=${dashboardReduxState.eventScheduleId}&isPackage=${isPckg}`,
      };
      dispatch(setGlobalLoading(true));
      const request = await axiosInstance(config);
      dispatch(setGlobalLoading(false));
      if (request.status === 200) {
        if (request.data.statusCode === 200) {
          // dispatch(dashboardActions.setCalendarSessionId(id));
          dispatch(dashboardActions.setEventScheduleData(request.data.data));
          setSessionDataToDisplay({
            ...request.data.data,
            eventPricingList: request.data.data.eventPricingList.map((d) => {
              // d.color = progressColors[Math.floor(Math.random() * progressColors.length)]
              // d.color = "bg-black"
              let color = progressColors[Math.floor(Math.random() * progressColors.length)].replace("bg-", "")

              return {
                ...d,
                // textcolor: "text-" + color,
                // color: "bg-" + color,
                textcolor: "text-primary",
                color: "bg-primary",
              };
            }),
            addonsPricingList: request.data.data.addonsPricingList.map((d) => {
              // d.color = progressColors[Math.floor(Math.random() * progressColors.length)]
              let color = progressColors[Math.floor(Math.random() * progressColors.length)].replace("bg-", "")
              return {
                ...d,
                // textcolor: "text-" + color,
                // color: "bg-" + color,
                capacity: d.capacity || 100,
                textcolor: "text-primary",
                color: "bg-primary",
              };
            })
          });
        }
      }
      await getEventScheduleMetricsDetail()
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardReduxState.updateSessionComp]);

  const onBackClick = () => {
    if (backState === 0) {
      navigate("/myschedule", { replace: true });
    } else {
      setBackState(0);
    }
  };

  const handleDateTimeModalOpen = () => setDateTimeModalOpen(true);
  const handleDateTimeModalClose = () => setDateTimeModalOpen(false);

  const handleLocationModalOpen = () => setLocationModalOpen(true);
  const handleLocationModalClose = () => setLocationModalOpen(false);

  const handleBookingLinkModalOpen = () => { setBookingLinkModalOpen(true); }
  const handleBookingLinkModalClose = () => setBookingLinkModalOpen(false);

  const handleScanTicketTokenModalOpen = () => { setScanTicketTokenModalOpen(true); }
  const handleScanTicketTokenModalClose = () => setScanTicketTokenModalOpen(false);

  const handleOpenCancelModal = () => setOpenCancelModal(true);
  const handleCloseCancelModal = () => setOpenCancelModal(false);


  const handleCancelSession = async () => {
    const data = {
      eventScheduleId: sessionDataToDisplay.instanceId,
    };

    dispatch(setGlobalLoading(true));
    const result = await axiosInstance.delete(
      // `${getUrlForEvent()}schools/deleteScheduleTheClass`,
      `${getUrlForEvent()}schedule/delete`,
      {
        data,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": userToken,
        },
      }
    );
    dispatch(setGlobalLoading(false));

    if (result.data.statusCode === 200) {
      addSuccessToast("Cancelled Successfully");
      dispatch(dashboardActions.setCalendarSessionId(-1));
      dispatch(dashboardActions.setCalendarOpen(false));
      navigate("/home/dashboard");
    } else {
      addErrorToast(result.data.message);
    }
  };

  const [cancelText, setCancelText] = React.useState("Cancel Class");

  const onCancel = async () => {
    if (!dataToDisplay.isPackage) {
      setCancelText(
        t("myEvents.cancelingRefundMsg")
      );
      handleOpenCancelModal();
    } else {
      addErrorToast(t("myEvents.cancelSingleSessionMsg"));
    }
  };

  const handleSessionClick = async (id) => {
    if (dashboardReduxState.eventScheduleId === id) {
      dispatch(dashboardActions.setCalendarSessionId(-1));
      dispatch(dashboardActions.setCalendarOpen(false));
      navigate("/home/dashboard");
      return;
    }
    addToast(t("myschedule.loadingSessionDetails"));
    const isPckg = sessionDataToDisplay.isPackage;
    const config = {
      method: "get",
      url: `${getUrlForEvent()}schedule/get?eventScheduleId=${id}&isPackage=${isPckg}`,
      headers: {
        "x-access-token": userToken,
      },
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {

        dispatch(dashboardActions.setEventId(request.data.data.eventId._id));
        dispatch(dashboardActions.setEventData(request.data.data.eventId));
        dispatch(dashboardActions.setCalendarSessionId(id));
        dispatch(dashboardActions.setEventScheduleId(request.data.data._id));
        dispatch(dashboardActions.setEventScheduleData(request.data.data));
        // navigate("/myschedule/detail");
        window.location.reload();
      }
    }
  };

  const ticketBought = (scheduleClass, row) => {
    let ticketQty = 0;
    // scheduleClass.scheduleClassBookings
    if (scheduleClass.scheduleClassBookings && scheduleClass.scheduleClassBookings.length > 0) {
      scheduleClass.scheduleClassBookings.map((booking) => {
        if (booking.status === "Cancelled") {
          return booking;
        }
        if (booking.ticketsBought && booking.ticketsBought.length > 0) {
          booking.ticketsBought.map((ticket) => {
            if (ticket.ticketType === row.ticketType) {
              ticketQty = parseInt(parseInt(ticketQty) + parseInt(ticket.bookingQty))
            }
          })
        } else {
          ticketQty = parseInt(ticketQty) + parseInt(booking.capacity ? booking.capacity : 0);
        }
      })
    }
    return ticketQty;
  }

  const getEventScheduleMetricsDetail = async (sellerId) => {
    console.log("dashboardReduxState.eventScheduleId", dashboardReduxState.eventScheduleId)
    // const isPckg = dashboardReduxState.calendarClassData.isPackage;
    const isPckg = dashboardReduxState.eventScheduleData.isPackage;
    const config = {
      method: "get",
      url: `${getUrlForEvent()}getEventScheduleMetricsDetail?eventScheduleId=${dashboardReduxState.eventScheduleId}${sellerId ? `&sellerId=${sellerId}` : ``}`,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        // dispatch(dashboardActions.setCalendarSessionId(id));
        setEventScheduleMetricsDetail(request.data.data)
        setAllOverallBookingChartDetails([])
        setOverallBookingChartDetails({})
        setTimelineData([])
        if (request.data.data.salesEventMetrics && request.data.data.salesEventMetrics.length > 0) {
          let tempSalesChannelsWithEventMetrics = request.data.data.salesEventMetrics ? request.data.data.salesEventMetrics.filter((f) => f.name !== "all" && f.isDeleted == false).map((d) => ({ ...d, name: d.name === "all" ? t("myEvents.allSalesChannels") : (d.name === "direct_sales" ? "Direct Sales" : d.name) })) : []
          setSalesChannelsWithEventMetrics(tempSalesChannelsWithEventMetrics)
          setRawCommissionData(tempSalesChannelsWithEventMetrics.filter((f) => f.sellerId !== "direct_sales"))
          if (metricsFilter == "all" && metricsData && Object.keys(metricsData).length <= 0) {
            setMetricsData(request.data.data.salesEventMetrics ? request.data.data.salesEventMetrics.find((f) => f.sellerId == "" && f.name == "all") : {})
            setAllMetricsData(request.data.data.salesEventMetrics ? request.data.data.salesEventMetrics.find((f) => f.sellerId == "" && f.name == "all") : {})
          }
        }
        if (request.data.data.overallBookingChartDetails && request.data.data.overallBookingChartDetails.length > 0) {
          setAllOverallBookingChartDetails(request.data.data.overallBookingChartDetails)
          if (metricsFilter == "all" && metricsData && Object.keys(metricsData).length <= 0) {
            let overallBookingChartDetails = request.data.data.overallBookingChartDetails.find((f) => ((metricsFilter == "all" && f.sellerId == "") || f.sellerId == metricsFilter))


            if (overallBookingChartDetails
              && overallBookingChartDetails.overallBookingChartDetails
              && Object.keys(overallBookingChartDetails.overallBookingChartDetails).length > 0) {
              let overallBookingChartDetailsObj = overallBookingChartDetails.overallBookingChartDetails

              setOverallBookingChartDetails(overallBookingChartDetailsObj)
              if (range == "daily") {
                setTimelineData(overallBookingChartDetailsObj['daily'] || [])
              } else if (range == "weekly") {
                setTimelineData(overallBookingChartDetailsObj['weekly'] || [])
              } else if (range == "monthly") {
                setTimelineData(overallBookingChartDetailsObj['monthly'] || [])
              }
            }
          }
        }
      }
    }
  }

  const commissionData = useMemo(
    () =>
      rawCommissionData.map((item) => {
        const b = item.calculateSalesCommission?.commissionBreakdown ?? {};
        const modelType = b.commissionModel?.toLowerCase().includes("flat")
          ? "Flat"
          : "Tiered";
        return {
          partner: item.name || b.partnerName || item.sellerReferenceId,
          ticketsSold: b.ticketsSold ?? item.totalTicketsBooking ?? 0,
          commissionModel: b.commissionModel,
          commissionType: modelType,
          totalCommission:
            typeof item.calculateSalesCommission?.totalCommission === "number"
              ? item.calculateSalesCommission.totalCommission
              : parseFloat(
                (item.calculateSalesCommission?.totalCommission || "0")
                  .toString()
                  .replace(/[€]/g, "")
              ),
          calculationBreakdown: b.calculationBreakdown,
          ticketsEarning: item.totalTicketsEarning ?? 0,
          addonsEarning: item.totalAddonsEarning ?? 0,
          ticketTypes: item.eventPricingList ?? [],
          addonItems: item.addonsPricingList ?? [],
        };
      }),
    [rawCommissionData]
  );

  return (
    <TwMainLayout
      // headTitle={`${dashboardReduxState.eventData.eventName} ${backState == 1 ? ` | ${t("bookings.bookingTitle")}` : ""}`}
      headTitle={``}
      breadcrumbs={[
        { title: t("pageTitle.myEvents"), onClick: () => { onBackClick(); } },
        { title: `${dashboardReduxState.eventData.eventName} ${backState == 1 ? ` | ${t("bookings.bookingTitle")}` : ""}` },
      ]}
      children={
        <TwContainer
          className=""
        >
          <div className={""}>
            <div className="flex flex-col w-full">
              <div className="flex flex-col gap-3 w-full">
                <div className="[flex] [flex-col sm:flex-row] grid grid-cols-1 sm:grid-cols-2  gap-8">
                  <div className="flex flex-auto flex-col gap-2">
                    <div className={"w-full h-44 md:h-72 flex justify-start"}>
                      {dataToDisplay.eventPhoto ? (
                        <img
                          className={
                            // "w-full h-[283px] object-cover object-fill rounded-2xl"
                            // "[sm:min-w-60] [lg:min-w-72] m:h-60 lg:h-72 rounded-2xl"
                            "w-full sm:h-60 lg:h-72 object-cover rounded-2xl border border-gray-200"
                          }
                          src={dataToDisplay.eventPhoto}
                          alt={""}
                        />
                      ) : (<img
                        className={
                          "w-full sm:h-60 lg:h-72 object-cover rounded-2xl"
                        }
                        src={defaultImage}
                        alt={""}
                      />)}
                    </div>
                    <div className={"grow"}>
                      <h2 className={"font-bold text-xl md:text-3xl"}>
                        {dataToDisplay.eventName}
                      </h2>
                      <p className={"text-sm md:text-base"}>
                        {dataToDisplay.tagLines}
                      </p>
                      <div
                        className={
                          "min-w-40 flex gap-2 items-left bg-white rounded-lg"
                        }
                      >
                        <TwRating
                          rating={dataToDisplay.rating}
                        />
                      </div>
                      <p className={"text-base text-secondary"}> {(sessionDataToDisplay?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1) ? t("myEvents.classInstanceIsCancelled") : ""}</p>
                      <div className="hidden [flex] flex-col justify-start w-full mt-5">
                        <p className={"text-base"}>{t("myEvents.shareTheLinkBelowMsg")}</p>
                        <div className="flex justify-center items-center w-full mt-5 bg-list-hover rounded-2xl border border-gray-300">
                          <div className="max-h-6 flex-1 pl-2 text-black my-0 mx-5 truncate cursor-pointer"
                            onClick={() => {
                              navigator.clipboard.writeText(bookingLink);
                              addSuccessToast(t("myEvents.copied"));
                            }}
                          >
                            {bookingLink}
                          </div>
                          <div className="flex flex-none bg-secondary py-2 px-5 rounded-e-2xl">
                            <button className="cursor-pointer" type="button" underline="none" onClick={() => {
                              navigator.clipboard.writeText(bookingLink);
                              addSuccessToast(t("myEvents.copied"));
                            }}>
                              <img
                                className={"w-7"}
                                src={copyOrange}
                                alt={""}
                              />
                            </button>
                            <button className="cursor-pointer" type="button" underline="none" target="_blank" onClick={() => {
                              window.open(bookingLink, '_blank');
                            }}>
                              <img
                                className={"w-7 ml-3 mr-3"}
                                src={shareOrange}
                                alt={""}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-auto flex-col gap-6 justify-top items-left pt-6">
                    {false && (<div className="flex flex-col justify-start max-w-full sm:max-w-md">
                      <p className={"text-base"}>{t("myEvents.eventPageLink")}</p>
                      <div className="flex justify-center items-center w-full mt-5 bg-list-hover rounded-2xl border border-gray-300">
                        <div className="max-h-6 flex-1 pl-2 text-black my-0 mx-5 truncate cursor-pointer"
                          onClick={() => {
                            navigator.clipboard.writeText(bookingLink);
                            addSuccessToast(t("myEvents.copied"));
                          }}
                        >
                          {bookingLink}
                        </div>
                        <div className="flex flex-none bg-secondary py-2 px-5 rounded-e-2xl">
                          <button className="cursor-pointer" type="button" underline="none" onClick={() => {
                            navigator.clipboard.writeText(bookingLink);
                            addSuccessToast(t("myEvents.copied"));
                          }}>
                            <img
                              className={"w-7"}
                              src={copyOrange}
                              alt={""}
                            />
                          </button>
                          <button className="cursor-pointer" type="button" underline="none" target="_blank" onClick={() => {
                            window.open(bookingLink, '_blank');
                          }}>
                            <img
                              className={"w-7 ml-3 mr-3"}
                              src={shareOrange}
                              alt={""}
                            />
                          </button>
                        </div>
                      </div>
                    </div>)}
                    <div className="flex justify-center items-center md:w-4/5">
                      <div className="flex-none">
                        <img
                          className={""}
                          src={greentime}
                          alt={""}
                        />
                      </div>
                      <div className="flex-1 pl-2">
                        <div className="text-gray-500 text-sm">{t("myEvents.eventDate")} </div>
                        <div className="text-black text-base">
                          {sessionDataToDisplay.eventDate ? format(parseISO(sessionDataToDisplay.eventDate), "EEEE, MMMM d 'at' HH:mm") + " - " + format(parseISO(sessionDataToDisplay?.eventEndDate), "HH:mm") : ""}
                        </div>
                        <div className="text-gray-500 text-xs">
                          {sessionDataToDisplay?.allEventSchedules && sessionDataToDisplay?.allEventSchedules.length > 1 ? "This Class has multiple instances" : ""}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center items-center md:w-4/5">
                      <div className="flex-none">
                        <img
                          className={""}
                          src={greenlocation}
                          alt={""}
                        />
                      </div>
                      <div className="flex-1 pl-2">
                        <div className="text-gray-500 text-sm">{t("myEvents.venue")} </div>
                        <div className="text-black text-base">
                          <p className="font-bold">{sessionDataToDisplay && sessionDataToDisplay?.location ? sessionDataToDisplay?.location.addressName : ""}</p>
                          <p className="line-clamp-2">{sessionDataToDisplay && sessionDataToDisplay?.location ? sessionDataToDisplay?.location.address : ""}</p>
                        </div>
                      </div>
                    </div>
                    <div className="flex py-3 gap-3">
                      <div className="flex-1 sm:flex-none">
                        <TwPopover
                          buttonClassName={"bg-info text-white rounded-lg w-full sm:w-40 p-3"}
                          buttonContent={(<span className={"flex flex-row items-center"}>
                            <p className={"w-full"}>{t("myEvents.actions")}</p>
                            <img src={dropdownbottom} alt={""} />
                          </span>)}
                        >
                          <div className={"flex flex-col gap-3 py-5"}>
                            {/* <button
                              disabled={popoverOptionsDisabled}
                              onClick={() => {

                                dispatch(dashboardActions.setEventData(sessionDataToDisplay.eventId));
                                dispatch(dashboardActions.setEventId(sessionDataToDisplay.eventId._id));
                                // dispatch(dashboardActions.setCalendarSessionId(sessionDataToDisplay.eventId._id));
                                dispatch(dashboardActions.setEventScheduleData(sessionDataToDisplay));
                                navigate("/myevents/detail");
                              }}
                              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
                            >
                              {t("myEvents.editEventDetails")}
                            </button> */}
                            {/* <button
                              disabled={popoverOptionsDisabled}
                              onClick={() => {
                                handleDateTimeModalOpen();
                              }}
                              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
                            >
                              {t("myEvents.changeSchedule")}
                            </button> */}
                            {/* <button
                              disabled={popoverOptionsDisabled}
                              onClick={() => {
                                handleLocationModalOpen();
                              }}
                              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
                            >
                              {t("inputFieldsTitle.updateLocation")}
                            </button> */}
                            {/* <button disabled={popoverOptionsDisabled} onClick={onCancel} className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}>
                              {t("inputFieldsTitle.cancel")}
                            </button> */}
                            {/* <button
                              disabled={popoverOptionsDisabled}
                              onClick={handleBookingLinkModalOpen}
                              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
                            >
                              Share Booking Link
                            </button> */}
                            <button
                              disabled={popoverOptionsDisabled}
                              // onClick={onClickShareLink}
                              onClick={handleScanTicketTokenModalOpen}
                              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
                            >
                              {t("myEvents.shareScanTicketToken")}
                            </button>
                            <button
                              disabled={popoverOptionsDisabled}
                              // onClick={onClickShareLink}
                              onClick={() => { setIssueFreeTicketModalOpen(true) }}
                              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
                            >
                              {t("myEvents.issueComplementaryTicket")}
                            </button>
                            <button
                              disabled={popoverOptionsDisabled}
                              onClick={onCancel}
                              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
                            >
                              {t("myEvents.cancelEvent")}
                            </button>
                          </div>
                        </TwPopover>
                      </div>
                      <div className="flex-none flex">
                        <TwButton
                          variant="secondary"
                          className="!rounded-lg"
                          onClick={() => {
                            dispatch(dashboardActions.setEventData(sessionDataToDisplay.eventId));
                            dispatch(dashboardActions.setEventId(sessionDataToDisplay.eventId._id));
                            dispatch(dashboardActions.setEventScheduleData(sessionDataToDisplay));
                            navigate("/myevents/detail");
                          }}
                        >
                          <EditPencilIcon className="text-white" />
                          &nbsp;&nbsp;{t("myEvents.editEvent")}
                        </TwButton>
                      </div>
                      {sessionDataToDisplay?.allEventSchedules && sessionDataToDisplay?.allEventSchedules.length > 1 ? (<div className="flex flex-col justify-start items-left">

                        <div className="flex-none flex w-full">
                          <TwPopover
                            buttonClassName={"bg-secondary text-white rounded-lg w-full sm:w-auto p-3 px-3 sm:px-6"}
                            buttonContent={(<span className={"flex flex-row gap-2 sm:gap-4 items-center"}>
                              <img src={menu_schedule} alt={""} />
                              <p className={"w-auto truncate"}>{t("myEvents.pickAnotherInstance")}</p>
                              <img src={dropdownbottom} alt={""} />
                            </span>)}
                          >
                            <div className="flex-none">
                              <MultiCalendar
                                className="bookzy-calendar preview-click px-2.5 py-1"
                                currentDate={new DateObject(sessionDataToDisplay.eventDate)}
                                weekDays={["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
                                // readOnly
                                single
                                onChange={(dates) => {

                                  const dateTransformed = moment(dates.toDate()).format("MM/DD/YYYY");
                                  const selectedDatesTransformed = eventDates ? eventDates.map(
                                    (day) => moment(day).format("MM/DD/YYYY")
                                  ) : [];
                                  let selectindex = selectedDatesTransformed.indexOf(dateTransformed);
                                  // let selectindex = sessionDataToDisplay.allEventSchedules.find(o => moment(o.eventDate).isSame(moment(dateTransformed).format("MM/DD/YYYY")));

                                  if (selectindex > -1) {
                                    if (!moment(dateTransformed).isSame(moment(sessionDataToDisplay.eventDate).format("MM/DD/YYYY"))) {
                                      handleSessionClick(sessionDataToDisplay.allEventSchedules[selectindex]._id);
                                    } else { console.log("same"); }
                                  }

                                  // setCourseDates([...courseDates]);
                                  // handleSessionClick();
                                  return false;
                                }}
                                mapDays={({
                                  date,
                                  today,
                                  selectedDate,
                                  currentMonth,
                                  isSameDate,
                                }) => {
                                  let props = {};

                                  // const dateTransformed = date.toDate();
                                  const dateTransformed = moment(date.toDate()).format("MM/DD/YYYY");
                                  /* const selectedDatesTransformed = selectedDate ? selectedDate.map(
                                    // (day) => day.toDate()
                                    (day) => moment(day.toDate()).format("MM/DD/YYYY")
                                  ) : []; */
                                  const selectedDatesTransformed = eventDates ? eventDates.map(
                                    // (day) => day.toDate()
                                    (day) => moment(day).format("MM/DD/YYYY")
                                  ) : [];
                                  /* if (moment(moment(date.toDate()).format("MM/DD/YYYY")).isSame(moment(today).format("MM/DD/YYYY"))) {
                                    props.className = "default-current-date";
                                  } */

                                  if (selectedDatesTransformed.indexOf(dateTransformed) > -1) {
                                    props.className = "default-class-dates";
                                  }

                                  if (moment(moment(date.toDate()).format("MM/DD/YYYY")).isSame(moment(sessionDataToDisplay.eventDate).format("MM/DD/YYYY"))) {
                                    props.className = "default-selected-date";
                                  }

                                  return props;
                                }}
                              />
                            </div>
                          </TwPopover>
                        </div>
                      </div>) : ""}
                    </div>
                  </div>
                </div>
                <div className="mt-10 border-2 border-gray-200 rounded-xl w-full [md:w-8/12 xl:w-6/12]">
                  {/* <div className="grid grid-cols-2 gap-3"> */}

                  <div className="flex justify-between border-b-2 border-bright-gray p-5">
                    <h3 className={"text-black text-2xl sm:text-3xl"} >
                      {t("myEvents.eventPageLink")}
                    </h3>
                    <div className="flex gap-2 justify-end items-center">
                      <TwButton
                        variant={"secondary"}
                        className={"truncate"}
                        onClick={() => {
                          window.open(bookingLink, '_blank');
                        }}>

                        {t("myEvents.preview")}&nbsp;<ArrowTopRightOnSquareIcon className="size-5" />
                      </TwButton>
                    </div>
                  </div>
                  <div className="flex flex-col gap-3 p-5">
                    {/* <TwInputGroup
                      // label={""}
                      className={"md:!w-full"}
                      name={"businessName"}
                      value={bookingLink}
                    /> */}
                    <input
                      readOnly
                      type="text"
                      value={bookingLink}
                      className="block w-full rounded-md bg-white px-4 py-2.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                      onFocus={async (e) => {
                        e.target.select()
                        try {
                          await navigator.clipboard.writeText(bookingLink);
                          addSuccessToast(t("myEvents.copied"));
                        } catch (e) {
                          addErrorToast(t("myEvents.failedToCopy"));
                        }
                      }}
                    />
                    <div className="flex gap-3">
                      <button
                        type="button"
                        className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 ring-0 ring-inset ring-gray-300 hover:bg-gray-50"
                        onClick={async () => {
                          try {
                            await navigator.clipboard.writeText(bookingLink);
                            setCopyText(t("myEvents.copied"));
                            setTimeout(() => {
                              setCopyText(t("myEvents.copy"));
                            }, 3000);
                            addSuccessToast(t("myEvents.copied"));
                          } catch (e) {
                            addErrorToast(t("myEvents.failedToCopy"));
                          }
                        }}
                      >
                        <span className={"flex gap-2 items-center"}>
                          {/* {copyText == "Copy" || copyText == "Kopiëren" ? (<img src={copy_squares} alt={""} />) : ( */}
                          {copyText == "Copy" || copyText == "Kopiëren" ? (
                            <svg className={"text-secondary"} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          ) : (
                            <svg className={"text-secondary"} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 15L14 17L18 13M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          )}
                          <p className={"text-sm font-semibold text-black"}>{copyText}</p>
                        </span>
                      </button>
                      <button
                        type="button"
                        className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 ring-0 ring-inset ring-gray-300 hover:bg-gray-50"
                        onClick={async () => {
                          setEmbedCodeDialogOpen(true);
                        }}
                      >
                        <span className={"flex gap-2 items-center"}>
                          <CodeBracketIcon className="size-5" />
                          <p className={"text-sm font-semibold text-black"}>{t("myEvents.embedBookingWidget")}</p>
                        </span>
                      </button>
                    </div>
                    <TwConfirmDialog
                      dialogOpen={embedCodeDialogOpen}
                      dialogType=""
                      dialogTitle={t("myEvents.embedBookingWidgetCode")}
                      dialogMessage={""}
                      isConfirmBtn={false}
                      isCloseBtn={false}
                      btnCloseText={t("inputFieldsTitle.close")}
                      btnConfirmVariant="secondary"
                      btnConfirmText={<span className={"flex gap-2 items-center"}>
                        {/* {copyText == "Copy" || copyText == "Kopiëren" ? (<img src={copy_squares} alt={""} />) : ( */}
                        {copyText == "Copy" || copyText == "Kopiëren" ? (
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 15L14 17L18 13M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        )}
                        <p className={"text-sm font-semibold text-white"}>{copyText}</p>
                      </span>}
                      onClose={() => {
                        setEmbedCodeDialogOpen(false);
                      }}
                      onConfirm={() => {
                        setEmbedCodeDialogOpen(false);
                        navigator.clipboard.writeText(codeBlockData);
                        addSuccessToast(t("myEvents.copied"));
                      }}
                    >
                      <div className="flex flex-col gap-4 justify-end items-end">
                        <TwTextarea
                          outerClassName={"w-full md:!max-w-full"}
                          value={codeBlockData}
                          row={3}
                          onClick={(e) => {
                            e.target.select()
                            navigator.clipboard.writeText(codeBlockData);
                            addSuccessToast(t("myEvents.copied"));
                          }}
                        />
                        <button
                          type="button"
                          className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 ring-0 ring-inset ring-gray-300 hover:bg-gray-50"
                          onClick={async () => {
                            try {
                              await navigator.clipboard.writeText(codeBlockData);
                              setCopyText(t("myEvents.copied"));
                              setTimeout(() => {
                                setCopyText(t("myEvents.copy"));
                              }, 3000);
                              addSuccessToast(t("myEvents.copied"));
                            } catch (e) {
                              addErrorToast(t("myEvents.failedToCopy"));
                            }
                          }}
                        >
                          <span className={"flex gap-2 items-center"}>
                            {/* {copyText == "Copy" || copyText == "Kopiëren" ? (<img src={copy_squares} alt={""} />) : ( */}
                            {copyText == "Copy" || copyText == "Kopiëren" ? (
                              <svg className={"text-secondary"} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            ) : (
                              <svg className={"text-secondary"} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 15L14 17L18 13M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            )}
                            <p className={"text-sm font-semibold text-black"}>{copyText}</p>
                          </span>
                        </button>
                      </div>
                    </TwConfirmDialog>
                  </div>
                </div>
                <div className="mt-2 border-2 border-gray-200 rounded-xl w-full [md:w-8/12 xl:w-6/12]">
                  {/* <div className="grid grid-cols-2 gap-3"> */}

                  <div className="flex justify-between border-b-2 border-bright-gray p-5">
                    <h3 className={"text-black text-2xl sm:text-3xl"} >
                      {t("myEvents.eventMetrics")}
                    </h3>
                    <div className="flex gap-2 justify-end items-center">
                      <TwButton variant={"default"} onClick={() => {
                        setMetricsFilter('all')
                        setMetricsData({})
                        dispatch(
                          dashboardActions.setUpdateSessionComp(
                            dashboardReduxState.updateSessionComp + 1
                          )
                        )
                      }}>
                        <ArrowPathIcon aria-hidden="true" className="size-5 text-black forced-colors:text-[Highlight]" />
                      </TwButton>
                      <TwListBox
                        value={metricsFilter}
                        options={
                          [

                            { value: "all", title: t("myEvents.allSalesChannels"), data: eventScheduleMetricsDetail.salesEventMetrics ? eventScheduleMetricsDetail.salesEventMetrics.find((f) => f.sellerId == "" && f.name == "all") : {} },
                            ...eventScheduleMetricsDetail.salesEventMetrics ? eventScheduleMetricsDetail.salesEventMetrics.filter((f) => f.isDeleted == false).map((d) => ({ value: d.sellerId, title: d.name === "all" ? t("myEvents.allSalesChannels") : (d.name === "direct_sales" ? "Direct Sales" : (d.name + (d.offerLabel ? ` — ${d.offerLabel}` : ""))), data: d })) : []
                          ]}
                        dropdownArrow={(<FunnelIcon aria-hidden="true" className="size-5 text-black forced-colors:text-[Highlight]" />)}
                        onChange={(v) => {
                          setMetricsFilter(v.value)
                          setMetricsData(v.data)

                          let overallBookingChartDetails = (allOverallBookingChartDetails || []).find((f) => ((v.value == "all" && f.sellerId == "") || f.sellerId == v.value))


                          if (overallBookingChartDetails
                            && overallBookingChartDetails.overallBookingChartDetails
                            && Object.keys(overallBookingChartDetails.overallBookingChartDetails).length > 0) {
                            let overallBookingChartDetailsObj = overallBookingChartDetails.overallBookingChartDetails

                            setOverallBookingChartDetails(overallBookingChartDetailsObj)
                            if (range == "daily") {
                              setTimelineData(overallBookingChartDetailsObj['daily'] || [])
                            } else if (range == "weekly") {
                              setTimelineData(overallBookingChartDetailsObj['weekly'] || [])
                            } else if (range == "monthly") {
                              setTimelineData(overallBookingChartDetailsObj['monthly'] || [])
                            }
                          }

                        }}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-3 p-5">
                    <div className="flex gap-3">
                      <div
                        className={
                          "bg-white rounded-xl flex flex-col gap-4 cursor-pointer border-0 border-gray-200"
                        }
                      >
                        <dl className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5">
                          <div
                            className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-6 pb-4 pt-5"
                          >
                            <dt>
                              <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                <ShoppingCartIcon aria-hidden="true" className="size-5 text-white" />
                              </div>
                              <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("bookings.totalBookingTitle")}</p>
                            </dt>
                            <dd className="ml-12 flex items-baseline ">
                              {/* Total bookings must follow the sales-channel filter, so read the
                                  filtered `metricsData` (per-channel). A selected channel's count is
                                  authoritative even when it's 0; only fall back to the pinned
                                  `allMetricsData` for the "all" view while metricsData is (re)loading. */}
                              <p className="text-xl font-semibold text-gray-900">{metricsData?.totalBooking != undefined ? metricsData.totalBooking : (metricsFilter === 'all' ? (allMetricsData?.totalBooking || 0) : 0)}</p>
                            </dd>
                          </div>
                          <div
                            className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-6 pb-4 pt-5"
                          >
                            <dt>
                              <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                <TicketIcon aria-hidden="true" className="size-5 text-white" />
                              </div>
                              <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("myEvents.totalTicketsSold")}</p>
                            </dt>
                            <dd className="ml-12 flex items-baseline ">
                              {/* Records with filters */}
                              <p className="text-xl font-semibold text-gray-900">{metricsData?.eventPricingList ? metricsData.eventPricingList.reduce((accumulator, item) => {
                                return accumulator + item.ticketsBookedConfirmed;
                              }, 0) : 0}</p>

                              {/* Only all records */}
                              {/* <p className="text-xl font-semibold text-gray-900">{allMetricsData?.eventPricingList ? allMetricsData.eventPricingList.reduce((accumulator, item) => {
                                return accumulator + item.ticketsBookedConfirmed;
                              }, 0) : 0}</p> */}
                              {/* }, 0) : "bookingDetails.seatsBooked"}</p> */}
                            </dd>
                          </div>
                          <div
                            className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-6 pb-4 pt-5"
                          >
                            <dt>
                              <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                <TicketIcon aria-hidden="true" className="size-5 text-white" />
                              </div>
                              <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("myEvents.totalAddonsSold")}</p>
                            </dt>
                            <dd className="ml-12 flex items-baseline ">
                              {/* Records with filters */}
                              <p className="text-xl font-semibold text-gray-900">{metricsData?.addonsPricingList ? metricsData.addonsPricingList.reduce((accumulator, item) => {
                                return accumulator + item.addonsBookedConfirmed;
                              }, 0) : 0}
                              </p>

                              {/* Only all records */}
                              {/* <p className="text-xl font-semibold text-gray-900">{allMetricsData?.addonsPricingList ? allMetricsData.addonsPricingList.reduce((accumulator, item) => {
                                return accumulator + item.addonsBookedConfirmed;
                              }, 0) : 0}</p> */}
                              {/* }, 0) : "bookingDetails.seatsBooked"}</p> */}
                            </dd>
                          </div>
                          {/* {metricsFilter == "all" || metricsFilter == "direct_sales" ? (<div */}
                          {metricsFilter == "all" || metricsFilter == "direct_sales" ? (<div
                            className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-6 pb-4 pt-5"
                          >
                            <dt>
                              <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                <BanknotesIcon aria-hidden="true" className="size-5 text-white" />
                              </div>
                              <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("myEvents.totalRevenue")}</p>
                            </dt>
                            <dd className="ml-12 flex items-baseline ">
                              {/* Follow the filter: "direct_sales" has its own totalEarning (direct-only),
                                  so read metricsData; only fall back to the pinned allMetricsData for the
                                  "all" view while metricsData is (re)loading. */}
                              <p className="text-xl font-semibold text-gray-900">€{metricsData?.totalEarning != undefined ? metricsData.totalEarning : (metricsFilter === 'all' ? (allMetricsData?.totalEarning || 0) : 0)}</p>
                            </dd>
                          </div>) : metricsFilter != "all" && metricsFilter != "direct_sales" ? (<div
                            className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-6 pb-4 pt-5"
                          >
                            <dt>
                              <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                <BanknotesIcon aria-hidden="true" className="size-5 text-white" />
                              </div>
                              <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("myEvents.totalRevenue")}</p>
                            </dt>
                            <dd className="ml-12 flex items-baseline ">
                              {/* <p className="text-xl font-semibold text-gray-900">€{metricsData?.totalEarning ? metricsData.totalEarning : (bookingDetails.seatsEarning)}</p> */}
                              <p className="text-xl font-semibold text-gray-900">€{parseFloat((metricsData?.totalTicketsEarning ? parseFloat(metricsData.totalTicketsEarning) : 0) + (metricsData?.totalAddonsEarning ? parseFloat(metricsData.totalAddonsEarning) : 0)).toFixed(2)}</p>
                            </dd>
                          </div>) : (false && (
                            <>
                              <div
                                className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-6 pb-4 pt-5"
                              >
                                <dt>
                                  <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                    <BanknotesIcon aria-hidden="true" className="size-5 text-white" />
                                  </div>
                                  <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("myEvents.ticketsRevenue")}</p>
                                </dt>
                                <dd className="ml-12 flex items-baseline ">
                                  <p className="text-xl font-semibold text-gray-900">€{metricsData?.totalTicketsEarning ? parseFloat(metricsData.totalTicketsEarning).toFixed(2) : 0}</p>
                                </dd>
                              </div>
                              <div
                                className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-6 pb-4 pt-5"
                              >
                                <dt>
                                  <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                    <BanknotesIcon aria-hidden="true" className="size-5 text-white" />
                                  </div>
                                  <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("myEvents.addonsRevenue")}</p>
                                </dt>
                                <dd className="ml-12 flex items-baseline ">
                                  <p className="text-xl font-semibold text-gray-900">€{metricsData?.totalAddonsEarning ? parseFloat(metricsData.totalAddonsEarning).toFixed(2) : 0}</p>
                                </dd>
                              </div>
                            </>
                          ))}
                          {metricsFilter !== "all" && metricsData?.isCommissionApplicable && metricsData?.isCommissionApplicable == true && (<div
                            className="relative overflow-hidden rounded-lg bg-gray-200 border border-bright-gray px-6 pb-4 pt-5"
                          >
                            <dt>
                              <div className="absolute rounded-full bg-indigo-500 p-2.5">
                                <BanknotesIcon aria-hidden="true" className="size-5 text-white" />
                              </div>
                              <p className="ml-12 truncate text-xs font-medium text-gray-500">{t("myEvents.commission")}</p>
                            </dt>
                            <dd className="ml-12 flex items-baseline ">
                              <p className="text-xl font-semibold text-gray-900">€{metricsData?.isCommissionApplicable && metricsData?.isCommissionApplicable == true ? parseFloat(metricsData.calculateSalesCommission.finalCommissionWithBonusApplied).toFixed(2) : 0}</p>
                            </dd>
                          </div>)}
                        </dl>
                        {/* {Array.isArray(bookingDetails.bookedPeople) &&
                        bookingDetails.bookedPeople && bookingDetails.bookedPeople.length > 3 ? (
                        <div
                          className={`flex flex-row items-center -space-x-2 overflow-hidden`}
                        >
                          {bookingDetails.bookedPeople.slice(0, 3).map((person, i) => (
                            <div className='avatar' key={i}>
                              <div className='flex-none'>
                                <img
                                  src={person.profilePic}
                                  alt={person.fullName}
                                  title={person.fullName}
                                  className='rounded-full size-6 sm:size-8'
                                />
                              </div>
                            </div>
                          ))}
                          <div className='avatar placeholder'>
                            <div
                              className={`flex justify-center items-center rounded-full font-semibold text-xs size-6 bg-primary text-white border-2 border-white`}
                            >
                              <span>
                                +
                                {bookingDetails.bookedPeople.length - 3}
                              </span>
                            </div>
                          </div>
                        </div>
                      ) : bookingDetails.bookedPeople && bookingDetails.bookedPeople.length < 4 ? (
                        <div
                          className={`flex flex-row items-center -space-x-2 overflow-hidden`}
                        >
                          {bookingDetails.bookedPeople.map((person) => (
                            <div className='avatar' key={person.userId}>
                              <div className='flex-none'>
                                <img
                                  src={person.profilePic}
                                  alt={person.fullName}
                                  title={person.fullName}
                                  className='rounded-full size-6 sm:size-8 bg-black'
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <></>
                      )} */}
                      </div>
                      {false && (<div
                        className={"min-w-[182.74px] h-[105px] p-4 pl-0 bg-white rounded-xl flex flex-row justify-end gap-2 sm:gap-3 border-0 border-gray-200"} >
                        <TwRadialProgress progress={bookingDetails.seatsBookedPerc} />
                        <div>
                          <p
                            className={
                              "font-medium text-granite-gray text-xs text-center"
                            }
                          >
                            {/* Tickets&nbsp;Booked */}
                            {t("myEvents.ticketsBooked")}
                          </p>
                          <div className={"grid place-items-end"}>
                            <h3
                              className={"text-light-primary font-bold text-base sm:text-sm md:text-sm lg:text-sm"} >
                              {bookingDetails.seatsBooked}/{bookingDetails.seats}
                            </h3>
                          </div>
                        </div>
                      </div>)}
                    </div>
                    <div className="flex flex-col gap-6">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                        <div className="text-lg font-semibold">{t("myEvents.eventActivityOverTime")}</div>
                        <div className="flex gap-2 justify-center items-center">
                          {/* <Tabs value={range} onValueChange={setRange}>
                            <TabsList>
                              <TabsTrigger value="daily">Daily</TabsTrigger>
                              <TabsTrigger value="weekly">Weekly</TabsTrigger>
                              <TabsTrigger value="monthly">Monthly</TabsTrigger>
                            </TabsList>
                          </Tabs> */}
                          <Tab.Group selectedIndex={['daily', 'weekly', 'monthly'].indexOf(range)} onChange={(index) => {
                            let selectedTab = ['daily', 'weekly', 'monthly'][index]
                            setRange(selectedTab)

                            if (overallBookingChartDetails[selectedTab]) {
                              setTimelineData(overallBookingChartDetails[selectedTab])
                            }
                          }}>
                            <Tab.List className="inline-flex rounded-md bg-gray-100 p-1">
                              {['daily', 'weekly', 'monthly'].map((r) => (
                                <Tab
                                  key={r}
                                  className={({ selected }) =>
                                    `px-4 py-1.5 text-sm font-medium rounded-md ${selected ? 'bg-white shadow text-black' : 'text-gray-500'}`
                                  }
                                >
                                  {/* {r.charAt(0).toUpperCase() + r.slice(1)} */}
                                  {t("myEvents." + r)}
                                </Tab>
                              ))}
                            </Tab.List>
                          </Tab.Group>
                          <TwSelectGroup
                            // label={"Metric"}
                            // placeholder={"Select Metric"}
                            name={"metric"}
                            selectClass="!py-3 md:!py-3"
                            options={[
                              { value: "all", title: t("myschedule.allTab") },
                              { value: "orders", title: t("myEvents.orders") },
                              { value: "tickets", title: t("myEvents.tickets") },
                              { value: "addons", title: t("myEvents.addOns") },
                              { value: "revenue", title: t("myEvents.revenue") },
                            ]}
                            defaultValue={selectedMetric}
                            value={selectedMetric}
                            onChange={(event) => {

                              setSelectedMetric(event.target.value);
                            }} />
                        </div>
                      </div>
                      <div className="relative">
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={timelineData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="period" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            {(selectedMetric === 'all' || selectedMetric === 'orders') && <Bar dataKey="orders" fill={metrics.orders.color} name={metrics.orders.label} />}
                            {(selectedMetric === 'all' || selectedMetric === 'tickets') && <Bar dataKey="tickets" fill={metrics.tickets.color} name={metrics.tickets.label} />}
                            {(selectedMetric === 'all' || selectedMetric === 'addons') && <Bar dataKey="addons" fill={metrics.addons.color} name={metrics.addons.label} />}
                            {(selectedMetric === 'all' || selectedMetric === 'revenue') && <Bar dataKey="revenue" fill={metrics.revenue.color} name={metrics.revenue.label} />}
                          </BarChart>
                        </ResponsiveContainer>
                        {timelineData.length <= 0 && (<span className="absolute left-0 top-0 bottom-0 right-0 bg-gray-200 flex justify-center items-center rounded-lg">There is no booking yet.</span>)}
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-6">
                      <div className="w-full">
                        {/* <TwProgressBar value={45} max={100} /> */}
                        <div className="max-w-xl mt-3 py-4 bg-white rounded-2xl space-y-6">
                          <div className="flex justify-between items-start">
                            <div>
                              <h2 className="text-lg font-semibold text-gray-900">{t("myEvents.splitByTicketType")}</h2>
                            </div>
                            {/* <button className="text-sm text-indigo-600 bg-indigo-100 rounded-full px-3 py-1">This Week</button> */}
                          </div>

                          <div className="flex space-x-6">
                            <div className="relative w-32 h-32">
                              <svg className="w-full h-full" viewBox="0 0 36 36">
                                <circle
                                  className="text-gray-200"
                                  strokeWidth="3.8"
                                  stroke="currentColor"
                                  fill="transparent"
                                  r="16"
                                  cx="18"
                                  cy="18"
                                />
                                {[{ percent: bookingDetails.seatsBookedPerc }].reduce((acc, curr, idx) => {
                                  const percent = curr.percent;
                                  const startOffset = acc.offset;
                                  const arcLength = (percent / 100) * 100;
                                  const strokeDasharray = `${arcLength} ${100 - arcLength}`;
                                  acc.elements.push(
                                    <circle
                                      key={idx}
                                      // className={progressColors[Math.floor(Math.random() * progressColors.length)]}
                                      className={"text-primary"}
                                      // className={"text-pink-400"}
                                      strokeWidth="3.8"
                                      strokeLinecap="butt"
                                      stroke="currentColor"
                                      fill="transparent"
                                      r="16"
                                      cx="18"
                                      cy="18"
                                      strokeDasharray={strokeDasharray}
                                      strokeDashoffset={100 - startOffset}
                                    />
                                  );
                                  acc.offset += arcLength;
                                  return acc;
                                }, { elements: [], offset: 0 }).elements}
                                {/* {sessionDataToDisplay?.eventPricingList && sessionDataToDisplay?.eventPricingList.reduce((acc, curr, idx) => {
                              const percent = ((curr.ticketsBooked?.ticketsBookedConfirmed ? curr.ticketsBooked.ticketsBookedConfirmed : ticketBought(sessionDataToDisplay, curr)) / curr.capacity) * 100;
                              const startOffset = acc.offset;
                              const arcLength = (percent / 100) * 100;
                              const strokeDasharray = `${arcLength} ${100 - arcLength}`;
                              acc.elements.push(
                                <circle
                                  key={curr.ticketType}
                                  // className={progressColors[Math.floor(Math.random() * progressColors.length)]}
                                  className={curr.textcolor}
                                  // className={"text-pink-400"}
                                  strokeWidth="3.8"
                                  strokeLinecap="butt"
                                  stroke="currentColor"
                                  fill="transparent"
                                  r="16"
                                  cx="18"
                                  cy="18"
                                  strokeDasharray={strokeDasharray}
                                  strokeDashoffset={100 - startOffset}
                                />
                              );
                              acc.offset += arcLength;
                              return acc;
                            }, { elements: [], offset: 0 }).elements} */}
                              </svg>
                              <div className="absolute inset-0 flex items-center justify-center text-center">
                                <div>
                                  <p className="text-base text-gray-400">{metricsData?.eventPricingList ? metricsData.eventPricingList.reduce((accumulator, item) => {
                                    return accumulator + item.ticketsBookedConfirmed;
                                  }, 0) : 0}</p>
                                  <p className="text-xs text-indigo-900">{t("myEvents.ticketsSold")}</p>
                                  <p className="text-sm text-gray-400">({parseFloat(bookingDetails.seatsBookedPerc).toFixed(1)}%)</p>
                                </div>
                              </div>
                            </div>
                            {/* <TwRadialProgress progress={bookingDetails.seatsBookedPerc} /> */}
                            <div className="flex-1 space-y-3">
                              {/* {allMetricsData?.eventPricingList ? (
                                allMetricsData?.eventPricingList && allMetricsData?.eventPricingList.map((item, i) => { */}
                              {metricsData?.eventPricingList ? (
                                metricsData?.eventPricingList && metricsData?.eventPricingList.map((item, i) => {
                                  const percent = parseFloat(((item.ticketsBookedConfirmed ? item.ticketsBookedConfirmed : 0) / item.capacity) * 100).toFixed(2);
                                  return (
                                    <div key={i} className="flex flex-col [items-center] w-full">
                                      <div className="text-sm text-gray-800 flex gap-1">
                                        <span className="line-clamp-1 font-bold">{item.ticketType}</span> <span className="text-gray-400">({percent}%)</span> <span className="text-gray-400">€{item.amount}</span>
                                      </div>
                                      <div className="flex justify-between items-center gap-1">
                                        <TwProgressBar value={percent} color={item?.color || "bg-primary"} max={100} />
                                        <div className="text-sm font-semibold text-gray-900 w-12 text-right">{item.ticketsBookedConfirmed ? item.ticketsBookedConfirmed : 0}/{item.capacity}</div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : (sessionDataToDisplay?.eventPricingList && sessionDataToDisplay?.eventPricingList.map((item, i) => {
                                const percent = parseFloat(((item.ticketsBooked?.ticketsBookedConfirmed ? item.ticketsBooked.ticketsBookedConfirmed : ticketBought(sessionDataToDisplay, item)) / item.capacity) * 100).toFixed(2);
                                return (
                                  <div key={i} className="flex flex-col [items-center] w-full">
                                    <div className="text-sm text-gray-800 flex gap-1">
                                      <span className="line-clamp-1 font-bold">{item.ticketType}</span> <span className="text-gray-400">({percent}%)</span> <span className="text-gray-400">€{item.amount}</span>
                                    </div>
                                    <div className="flex justify-between items-center gap-1">
                                      <TwProgressBar value={percent} color={item.color} max={100} />
                                      <div className="text-sm font-semibold text-gray-900 w-12 text-right">{item.ticketsBooked?.ticketsBookedConfirmed ? item.ticketsBooked.ticketsBookedConfirmed : ticketBought(sessionDataToDisplay, item)}/{item.capacity}</div>
                                    </div>
                                  </div>
                                )
                              }))}
                            </div>
                          </div>

                        </div>
                        {false && (<div
                          className="p-2 sm:p-4 mt-2 bg-list-hover rounded-2xl hidden">
                          <table className="min-w-full divide-y divide-gray-300">
                            <thead className="">
                              <tr className="text-center">
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-base font-extrabold text-gray-900 sm:pl-6">
                                  {t("myEvents.ticketType")}
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                                  {t("myEvents.price")}
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                                  {t("myEvents.ticketsBooked")}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y-8 !border-y-0 divide-list-hover ">
                              {sessionDataToDisplay?.eventPricingList && [...sessionDataToDisplay?.eventPricingList].map((row, i) => (
                                <tr key={i} className="">
                                  <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-l-2xl truncate"><div>{row.ticketType}</div></td>
                                  <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base"><div>€{row.amount}</div></td>
                                  <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-r-2xl"><div>{row.ticketsBooked?.ticketsBookedConfirmed ? row.ticketsBooked.ticketsBookedConfirmed : ticketBought(sessionDataToDisplay, row)}/{row.capacity}</div></td>
                                </tr>
                              ))}

                            </tbody>
                          </table>
                        </div>)}
                      </div>
                      {sessionDataToDisplay?.addonsPricingList.length > 0 && (<div className="w-full">
                        {/* <p className={"font-semibold text-base mt-3"}>
                      Bookings by addons type
                    </p> */}

                        <div className="max-w-xl mt-3 py-4 bg-white rounded-2xl space-y-6">
                          <div className="flex justify-between items-start">
                            <div>
                              <h2 className="text-lg font-semibold text-gray-900">{t("myEvents.splitByAddonsType")}</h2>
                            </div>
                            {/* <button className="text-sm text-indigo-600 bg-indigo-100 rounded-full px-3 py-1">This Week</button> */}
                          </div>

                          <div className="flex space-x-6">
                            <div className="relative w-32 h-32">
                              <svg className="w-full h-full" viewBox="0 0 36 36">
                                <circle
                                  className="text-gray-200"
                                  strokeWidth="3.8"
                                  stroke="currentColor"
                                  fill="transparent"
                                  r="16"
                                  cx="18"
                                  cy="18"
                                />
                                {[{ percent: bookingDetails.seatsBookedAddonsPerc }].reduce((acc, curr, idx) => {
                                  const percent = curr.percent;
                                  const startOffset = acc.offset;
                                  const arcLength = (percent / 100) * 100;
                                  const strokeDasharray = `${arcLength} ${100 - arcLength}`;
                                  acc.elements.push(
                                    <circle
                                      key={idx}
                                      // className={progressColors[Math.floor(Math.random() * progressColors.length)]}
                                      className={"text-primary"}
                                      // className={"text-pink-400"}
                                      strokeWidth="3.8"
                                      strokeLinecap="butt"
                                      stroke="currentColor"
                                      fill="transparent"
                                      r="16"
                                      cx="18"
                                      cy="18"
                                      strokeDasharray={strokeDasharray}
                                      strokeDashoffset={100 - startOffset}
                                    />
                                  );
                                  acc.offset += arcLength;
                                  return acc;
                                }, { elements: [], offset: 0 }).elements}
                              </svg>
                              <div className="absolute inset-0 flex items-center justify-center text-center">
                                <div>
                                  <p className="text-base text-gray-400">{metricsData?.addonsPricingList ? metricsData.addonsPricingList.reduce((accumulator, item) => {
                                    return accumulator + item.addonsBookedConfirmed;
                                  }, 0) : 0}</p>
                                  <p className="text-xs text-indigo-900">{t("myEvents.addonsSold")}</p>
                                  <p className="text-sm text-gray-400">({parseFloat(bookingDetails.seatsBookedAddonsPerc).toFixed(1)}%)</p>
                                </div>
                              </div>
                            </div>
                            <div className="flex-1 space-y-3">
                              {metricsData?.addonsPricingList && metricsData?.addonsPricingList.length > 0 ? (
                                metricsData?.addonsPricingList.map((item, i) => {
                                  const percent = parseFloat(((item.addonsBookedConfirmed ? item.addonsBookedConfirmed : 0) / item.capacity) * 100).toFixed(2);
                                  return (
                                    <div key={i} className="flex flex-col [items-center] w-full">
                                      <div className="text-sm text-gray-800 flex gap-1">
                                        <span className="line-clamp-1 font-bold">{item.addonName}</span> <span className="text-gray-400">({percent}%)</span> <span className="text-gray-400">€{item.amountForTicket}</span>
                                      </div>
                                      <div className="flex justify-between items-center gap-1">
                                        <TwProgressBar value={percent} color={item?.color || "bg-primary"} max={100} />
                                        <div className="text-sm font-semibold text-gray-900 w-12 text-right">{item.addonsBookedConfirmed ? item.addonsBookedConfirmed : 0}/{item.capacity}</div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : sessionDataToDisplay?.addonsPricingList && sessionDataToDisplay?.addonsPricingList.length > 0 && sessionDataToDisplay?.addonsPricingList.map((item, i) => {
                                const percent = parseFloat(((item.addonsBooked?.addonsBookedConfirmed ? item.addonsBooked?.addonsBookedConfirmed : 0) / item.capacity) * 100).toFixed(2);
                                return (
                                  <div key={i} className="flex flex-col [items-center] w-full">
                                    <div className="text-sm text-gray-800 flex gap-1">
                                      <span className="line-clamp-1 font-bold">{item.addonName}</span> <span className="text-gray-400">({percent}%)</span> <span className="text-gray-400">€{item.amountForTicket}</span>
                                    </div>
                                    <div className="flex justify-between items-center gap-1">
                                      <TwProgressBar value={percent} color={item.color} max={100} />
                                      <div className="text-sm font-semibold text-gray-900 w-12 text-right">{item.addonsBooked?.addonsBookedConfirmed ? item.addonsBooked?.addonsBookedConfirmed : 0}/{item.capacity}</div>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>

                        </div>
                        {false && (<div
                          className="p-2 sm:p-4 mt-2 bg-list-hover rounded-2xl">
                          <table className="min-w-full divide-y divide-gray-300">
                            <thead className="">
                              <tr className="text-center">
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-base font-extrabold text-gray-900 sm:pl-6">
                                  {t("myEvents.addonName")}
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                                  {t("myEvents.price")}
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                                  {t("myEvents.addonsBooked")}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y-8 !border-y-0 divide-list-hover ">
                              {sessionDataToDisplay?.addonsPricingList && [...sessionDataToDisplay?.addonsPricingList].map((row, i) => (
                                <tr key={i} className="">
                                  <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-l-2xl truncate"><div>{row.addonName}</div></td>
                                  <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base"><div>€{row.amountForTicket}</div></td>
                                  <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-r-2xl"><div>{row.addonsBooked?.addonsBookedConfirmed ? row.addonsBooked.addonsBookedConfirmed : 0}</div></td>
                                </tr>
                              ))}

                            </tbody>
                          </table>
                        </div>)}
                      </div>)}
                    </div>

                    {/* Renders itself away when no included add-on has dietary enabled. */}
                    <DietarySummaryCard
                      dietarySummary={sessionDataToDisplay?.dietarySummary}
                    />

                    {/* <div className="text-lg font-semibold">Sales Contribution</div> */}

                  </div>
                </div>
                {salesChannelsWithEventMetrics.length > 0 && salesChannelsWithEventMetrics.filter((f) => f.totalBooking > 0).length > 0 && (<div className="mt-2 border-2 border-gray-200 rounded-xl w-full [md:w-8/12 xl:w-6/12]">

                  <SalesDistributionDashboard
                    eventScheduleMetricsDetail={eventScheduleMetricsDetail}
                    salesChannelsWithEventMetrics={salesChannelsWithEventMetrics}
                  />
                </div>)}
                <div className={"flex flex-row justify-end p-1"}>
                  <button className="hidden text-[#5265FF] cursor-pointer" type="button" underline="none" onClick={() => setBackState(true)}>Goto All bookings</button>
                </div>
                {false ? (
                  <div className={"flex flex-col gap-5"}>
                    <div className="">
                      <h4 className={"font-bold text-lg"}>
                        {t("myEvents.description")}
                      </h4>
                      <p className={"font-light text-base"}>
                        {(
                          dataToDisplay.description > 175 ? (
                            !isDescExpanded ? (
                              <>
                                {dataToDisplay.description.slice(0, 175)}
                                <span
                                  className={
                                    "text-gray-400 font-light text-base cursor-pointer"
                                  }
                                  onClick={() => setDescExpanded(true)}
                                >
                                  {t("myEvents.seeMore")}
                                </span>
                              </>
                            ) : (
                              <span>
                                {dataToDisplay.description}
                                <br />
                                <span
                                  className={
                                    "text-gray-400 font-light text-base cursor-pointer"
                                  }
                                  onClick={() => setDescExpanded(false)}
                                >
                                  {t("myEvents.seeLess")}
                                </span>
                              </span>
                            )
                          ) : (
                            <span>{dataToDisplay.description}</span>
                          )
                        )}
                      </p>
                    </div>
                    <div>
                      <h4 className={"font-bold text-lg"}>
                        {t("myEvents.whatToCarryTitle")}
                      </h4>
                      <p className={"font-light text-base"}>
                        {(
                          dataToDisplay.whatToCarry?.length > 175 ? (
                            !isWhatToCarryExpanded ? (
                              <>
                                {dataToDisplay.whatToCarry?.slice(0, 175)}
                                <span
                                  className={
                                    "text-gray-400 font-light text-base cursor-pointer"
                                  }
                                  onClick={() => setWhatToCarryExpanded(true)}
                                >
                                  {t("myEvents.seeMore")}
                                </span>
                              </>
                            ) : (
                              <span>
                                {dataToDisplay.whatToCarry}
                                <br />
                                <span
                                  className={
                                    "text-gray-400 font-light text-base cursor-pointer"
                                  }
                                  onClick={() => setWhatToCarryExpanded(false)}
                                >
                                  {t("myEvents.seeLess")}
                                </span>
                              </span>
                            )
                          ) : (
                            <span>{dataToDisplay.whatToCarry}</span>
                          )
                        )}
                      </p>
                    </div>
                    <div>
                      <h4 className={"font-bold text-lg"}>
                        {t("myEvents.cancelationPolicy")}
                      </h4>
                      {(
                        dataToDisplay?.eventCancelationPolicy?.isEnabled ? (
                          <p className={"font-light text-base"}>
                            {/* Cancelation is free in case booking is cancelled{" "}
                            <span className={"font-bold"}>
                              {dataToDisplay?.eventCancelationPolicy.text}
                            </span>{" "}
                            before start of the class. */}
                          </p>
                        ) : (
                          <p className={"font-light text-base"}>
                            {t("myEvents.freeCancelationNotAvailable")}
                          </p>
                        )
                      )}
                    </div>
                  </div>
                ) : ""}
              </div>
              <div>
                <SessionBooking
                  sessionDataToDisplay={sessionDataToDisplay}
                  displayHeader={false}
                  metricsFilterList={
                    [
                      { value: "all", title: t("myEvents.allSalesChannels"), data: eventScheduleMetricsDetail.salesEventMetrics ? eventScheduleMetricsDetail.salesEventMetrics.find((f) => f.sellerId == "" && f.name == "all") : {} },
                      ...eventScheduleMetricsDetail.salesEventMetrics ? eventScheduleMetricsDetail.salesEventMetrics.filter((f) => f.isDeleted == false).map((d) => ({ value: d.sellerId, title: d.name === "all" ? t("myEvents.allSalesChannels") : (d.name === "direct_sales" ? "Direct Sales" : (d.name + (d.offerLabel ? ` — ${d.offerLabel}` : ""))), data: d })) : []
                    ]}
                />
              </div>
            </div>
            <ChangeDateTimeModal
              open={dateTimeModalOpen}
              handleClose={handleDateTimeModalClose}
              sessionData={sessionDataToDisplay}
              instanceId={sessionDataToDisplay._id}
              handleUpdate={() =>
                dispatch(
                  dashboardActions.setUpdateSessionComp(
                    dashboardReduxState.updateSessionComp + 1
                  )
                )
              }
            />
            <ChangeLocationModal
              open={locationModalOpen}
              handleClose={handleLocationModalClose}
              sessionData={sessionDataToDisplay}
              instanceId={sessionDataToDisplay._id}
              handleUpdate={() =>
                dispatch(
                  dashboardActions.setUpdateSessionComp(
                    dashboardReduxState.updateSessionComp + 1
                  )
                )
              }
            />
            <TwConfirmDialog
              dialogOpen={openCancelModal}
              dialogType="warning"
              dialogTitle={t("myEvents.cancelSession")}
              dialogMessage={cancelText}
              onClose={async () => {
                handleCloseCancelModal();
              }}
              onConfirm={async () => {
                handleCancelSession()
              }}
            />
            <BookingLinkModal
              title={t("myEvents.bookingLinkGeneratedTitle", { eventName: dataToDisplay?.eventName })}
              subtitle={t("myEvents.bookingLinkGeneratedSubTitle")}
              open={bookingLinkModalOpen}
              handleClose={handleBookingLinkModalClose}
              bookingLink={bookingLink}
            />
            <BookingLinkModal
              title={t("myEvents.scanTicketTokenTitle", { eventName: dataToDisplay?.eventName })}
              subtitle={t("myEvents.scanTicketTokenSubTitle")}
              open={scanTicketTokenModalOpen}
              handleClose={handleScanTicketTokenModalClose}
              bookingLink={sessionDataToDisplay?.scanTicketToken || ""}
            />

            <IssueFreeTicketModal
              eventScheduleId={dashboardReduxState.eventScheduleId}
              eventScheduleData={dashboardReduxState.eventScheduleData}
              open={issueFreeTicketModalOpen}
              handleClose={() => setIssueFreeTicketModalOpen(false)}
              reload={() => {
                setMetricsData({});
                dispatch(
                  dashboardActions.setUpdateSessionComp(
                    dashboardReduxState.updateSessionComp + 1
                  )
                )
              }}
            />
          </div>
        </TwContainer>} />
  );
}
